import type { CatalogueEntry } from "../types";
// TODO(DS-5859): swap in 2026-specific thumbnails when artwork is available.
import imageDark from "../images/abs-boundaries.dark.webp";
import imageLight from "../images/abs-boundaries.light.webp";

export const entry: CatalogueEntry = {
  slug: "abs-boundaries-2026",
  displayName: `ABS Boundaries 2026`,
  datasetProductCode: `ABS-BOUNDARIES-2026`,
  subtitle: `The 2026 edition of the Australian Statistical Geography Standard.`,
  shortDescription: `ABS Boundaries 2026 is a digital representation of the 2026 edition of the Australian Statistical Geography Standard (ASGS) boundaries produced by the Australian Bureau of Statistics (ABS). The ASGS brings all the regions for which the ABS publishes statistics within the one framework, and a new edition is released for each Census. This product carries 2026 on its own, so it can be adopted independently of earlier editions, which remain available in ABS Boundaries - Legacy. The Mesh Blocks released are used in building all ASGS boundaries.
The ABS Boundaries 2026 dataset currently includes:
-	2026 ABS Mesh Blocks and Statistical Areas`,
  metadata: {
    dateAdded: 1785542400000,
    dataType: ["Polygons"],
    // TODO(DS-5859): confirm against the 2026 release notes.
    totalFeatureCount: 0,
    updateFrequency: `Quarterly`,
    license: `CC BY 4.0`,
    metadataXml: `[EXAMPLE](https://geoscape.com.au/)`,
    metadataJson: `[EXAMPLE](https://geoscape.com.au/)`,
  },
  // TODO(DS-5859): point at the 2026 documentation once published.
  // latestReleaseReportLink: `https://docs.geoscape.com.au/en/stable/abs_boundaries.html`,
  // productDescriptionLink: `https://docs.geoscape.com.au/en/stable/abs_boundaries.html`,
  imageLight,
  imageDark,
  searchTags: `ABS Boundaries 2026 ASGS Areas Census Census Mapping Demographic Study Economic Advantages Economic Disadvantages Geographic Analysis Socio-Economic Indexes Statistical Reporting Stats`,
  detail: () => import("../details/abs-boundaries-2026").then((m) => m.detail),
};

export default entry;
